"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _button = _interopRequireDefault(require("components/common/button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } // import { connect } from 'react-redux';
// import * as StoreActions from 'Store/actions/storeActions';
// import ReportAnalytics from 'Components/analytics/common';
// import AnalyticsService from 'Components/analytics/analyticsService';
var Prefooter = /*#__PURE__*/function (_React$Component) {
  function Prefooter(props) {
    var _this;
    _classCallCheck(this, Prefooter);
    _this = _callSuper(this, Prefooter, [props]);
    _this.state = _objectSpread({}, props);
    _this.showModal = _this.showModal.bind(_this);
    _this.submit = _this.submit.bind(_this);
    _this.linkClick = _this.linkClick.bind(_this);
    return _this;
  }
  _inherits(Prefooter, _React$Component);
  return _createClass(Prefooter, [{
    key: "showModal",
    value: function showModal() {
      //sets the link for leave button
      // this.props.dispatch(StoreActions.setModalLink(process.env.TRAVELERS_COM + 'register'));
      if (this.props.showCancel) {
        // this.props.dispatch(StoreActions.showModalDialog(true));
      } else {
        // this.props.dispatch(StoreActions.ResetState());
        window.location.assign(process.env.TRAVELERS_COM + 'register'); //should be https://www.travelers.com/register
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      //ReportAnalytics('click',this.props.location, '', '', 'login','', '', '');
      //sets the link for leave button
      // this.props.dispatch(StoreActions.setModalLink(process.env.LOGIN_URL));
      if (this.props.showCancel) {
        // this.props.dispatch(StoreActions.showModalDialog(true));
      } else {
        // this.props.dispatch(StoreActions.ResetState());
        window.location.assign(process.env.LOGIN_URL);
      }
    }
  }, {
    key: "linkClick",
    value: function linkClick() {
      // ReportAnalytics('click', this.props.location, '', '', 'TechnicalSupport:'+ process.env.TECHNICAL_SUPPORT, '', '', '');
      // let analyticService= new AnalyticsService();
      // analyticService.flush();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "align-center"
      }, /*#__PURE__*/React.createElement(_button["default"], {
        text: "Cancel",
        exit: "y",
        additionalAttribute: this.props.additionalAttribute,
        onClick: this.showModal,
        tabIndex: this.props.tabIndex,
        style: "tds-field tds-button--tertiary buttonwidth"
      }), /*#__PURE__*/React.createElement("hr", {
        className: "tds-field content-divider"
      }), /*#__PURE__*/React.createElement("h4", {
        className: "tds-field margin-top-xx-large"
      }, "ALREADY HAVE AN ACCOUNT?"), /*#__PURE__*/React.createElement(_button["default"], {
        trvAnalytics: "login",
        exit: "y",
        additionalAttribute: this.props.additionalAttribute,
        tabIndex: this.props.tabIndex ? this.props.tabIndex + 1 : '',
        text: "Log in",
        onClick: this.submit,
        style: "tds-field tds-button--tertiary buttonwidth"
      }), /*#__PURE__*/React.createElement("h4", null, "TECHNICAL SUPPORT"), /*#__PURE__*/React.createElement("p", {
        className: "tds-medium"
      }, "If you're having problems registering, call us for help."), /*#__PURE__*/React.createElement("a", {
        className: "tds-medium",
        onClick: this.linkClick,
        tabIndex: this.props.tabIndex ? this.props.tabIndex + 2 : '',
        href: 'tel:+' + process.env.TECHNICAL_SUPPORT
      }, process.env.TECHNICAL_SUPPORT), /*#__PURE__*/React.createElement("p", {
        className: "tds-medium"
      }, " 8 AM to 8 PM ET, Monday\u2013Friday"));
    }
  }]);
}(React.Component);
var _default = exports["default"] = Prefooter;